import React from 'react';

function NextPage(props) {
  return(
    <a className="pagination-next" onClick={props.onClick}>Next</a>
  );
}

export default NextPage;
